import React, { ReactElement } from 'react';
import { RouteComponentProps, Route, Switch, Redirect } from 'react-router-dom';
import CreateException from './CreateExceptionForm';
import EditException from './EditExceptionForm';
import { PromptView } from '../../../components/Prompt/PromptProvider';
import PromptProvider from '../../../components/Prompt/PromptProvider/PromptProvider';
import ViewException from './ViewException';
import SearchException from './SearchException';
import { RouteLoadDurationProvider } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';

/**
 * match.path from RouteComponentProps will have the current browser path
 */
export type ReceiveExceptionProps = RouteComponentProps;

/**
 * Component for Receive Exception Page
 * @component
 * @param {ReceiveExceptionProps} props
 */
const ReceiveException = ({ match }: ReceiveExceptionProps): ReactElement => {
  return (
    <RouteLoadDurationProvider>
      <Switch>
        <Route exact path={`${match.path}/create`} component={CreateException} />
        <Route exact path={`${match.path}/:exceptionId/edit`} component={EditException} />
        <Route exact path={`${match.path}/search`} component={SearchException} />
        <PromptProvider>
          <>
            <PromptView />
            <Route exact path={`${match.path}/:exceptionId`} component={ViewException} />
          </>
        </PromptProvider>
        <Route path={`${match.path}/`}>
          <Redirect to={`${match.path}/receive/search`} />
        </Route>
      </Switch>
    </RouteLoadDurationProvider>
  );
};

export default ReceiveException;
